import './App.css';
import Home from './Pages/HomePage';
import AboutUsPage from './Pages/AboutUsPage';
import UniversitiesPage from './Pages/UniversitiesPage';
import CoursesPage from './Pages/CoursesPage';
import ContactUsPage from './Pages/ContactUsPage';
import BlogsPage from './Pages/BlogsPage';
import BlogContent from './Components/BlogContent';
import {
  BrowserRouter,
  Routes,Route
} from "react-router-dom";
import ForgotPasswordPage from './Pages/ForgotPasswordPage';
import SignUpPage from './Pages/SignUpPage';
import SignInPage from './Pages/SignInPage';
import NotFound404 from './Components/NotFound404';
import RegistrationPage from './Pages/RegistrationPage';
import AdminPage from './Pages/AdminPage';

function App() {

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home/>}/>
          <Route path="/" element={<Home/>}/>
          <Route path="/about" element={<AboutUsPage/>}/>
          <Route path="/universities" element={<UniversitiesPage/>}/>
          <Route path="/courses" element={<CoursesPage/>}/>
          <Route path="/contact" element={<ContactUsPage/>}/>
          <Route path="/blogs" element={<BlogsPage/>}/>
          <Route path="/blogs/content" element={<BlogContent/>}/>
          <Route path="/signin" element={<SignInPage/>}/>
          <Route path="/signup" element={<SignUpPage/>}/>
          <Route path="/forgotpassword" element={<ForgotPasswordPage/>}/>
          <Route path="/upload" element={<RegistrationPage/>}/>
          <Route path="/admin/dashboard" element={<AdminPage/>}/>
          <Route path='*' element={<NotFound404/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
